<div id="breadcrumb" class="division">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class=" breadcrumb-holder">

                    <!-- Breadcrumb Nav -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="demo-1.html">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Contact</li>
                        </ol>
                    </nav>

                    <!-- Title -->
                    <h4 class="h4-sm steelblue-color">Contact Us</h4>

                </div>
            </div>
        </div> <!-- End row -->
    </div> <!-- End container -->
</div>

<div id="appointment-page" class="wide-60 appointment-page-section division pb-0">
    <div class="container">
        <div class="row">

            <div class="col-lg-8">
                <div class="txt-block pr-30">
                    <!-- Title -->
                    <h3 class="h3-md steelblue-color">Contact Us</h3>

                    <!-- Text -->
                    <p>Visit our clinic, call us, or reach out online — your health is just a message away
                    </p>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1.4s"
                                style="visibility: visible; animation-delay: 1.4s; animation-name: fadeInUp;">
                                <a href="service-2.html">

                                    <!-- Icon -->
                                    <span class="flaticon-133-smartphone-2 blue-color"></span>

                                    <!-- Text -->
                                    <div class="sbox-7-txt">

                                        <!-- Title -->
                                        <h5 class="h5-sm steelblue-color">Call Us</h5>

                                        <!-- Text -->
                                        <p class="p-sm"><a href="tel:+92 308 7912740" class="callusbtn">+92 308 7912740
</a></p>

                                    </div>

                                </a>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1.4s"
                                style="visibility: visible; animation-delay: 1.4s; animation-name: fadeInUp;">
                                <a href="service-2.html">
                                    <!-- Icon -->
                                    <span class="flaticon-008-ambulance-6 blue-color"></span>

                                    <!-- Text -->
                                    <div class="sbox-7-txt">

                                        <!-- Title -->
                                        <h5 class="h5-sm steelblue-color">Email Us</h5>

                                        <!-- Text -->
                                        <p class="p-sm"><a href="mailto:info@movementcliniclahore.com">infomovementclinic&#64;gmail.com</a></p>

                                    </div>

                                </a>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="sbox-7 icon-xs wow fadeInUp" data-wow-delay="1.4s"
                                style="visibility: visible; animation-delay: 1.4s; animation-name: fadeInUp;">
                                <a href="service-2.html">

                                    <!-- Icon -->
                                    <span class="flaticon-008-ambulance-6 blue-color"></span>

                                    <!-- Text -->
                                    <div class="sbox-7-txt">

                                        <!-- Title -->
                                        <h5 class="h5-sm steelblue-color">Location</h5>

                                        <!-- Text -->
                                        <p class="p-sm">Bashir NeuroSpine Institute, next to Services Hospital, Jail Road, Lahore</p>
                                    </div>

                                </a>
                            </div>
                        </div>
                    </div>

                </div> <!-- END APPOINTMENT FORM -->

            </div> <!-- END SERVICE DETAILS -->

            <!-- SIDEBAR -->
            <aside id="sidebar" class="col-lg-4">

                <!-- SIDEBAR TABLE -->
                <div class="sidebar-table blue-table sidebar-div mb-50">

                    <!-- Title -->
                    <h5 class="h5-md">Working Time</h5>

                    <!-- Text -->
                    <p class="p-sm">Day or night, we’re always here to provide quality care when you need it most
                    </p>

                    <!-- Table -->
                    <table class="table">
                        <tbody>
                            <tr>
                                <td>Mon – Sun</td>
                                <td> - </td>
                                <td class="text-right">24 Hours</td>
                            </tr>
                        </tbody>
                    </table>

                </div> <!-- END SIDEBAR TABLE -->


            </aside> <!-- END SIDEBAR -->
        </div> <!-- End row -->
    </div> <!-- End container -->

    <div class="row pt-5">
        <div class="col-lg-12">
            <!-- Google Map Start -->
            <div class="google-map">
                <!-- Google Map Iframe Start -->
                <div class="google-map-iframe">
                    <iframe  width="100%" height="350" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3398.230747224158!2d74.33862177430774!3d31.60013644319911!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39191b000be29aff%3A0x2c678249cb28b97f!2sMian%20G%20Polyclinic!5e0!3m2!1sen!2s!4v1751706663268!5m2!1sen!2s"  style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <!-- Google Map Iframe End -->
            </div>
            <!-- Google Map End -->
        </div>
    </div> <!-- End row -->
</div> <!-- End container -->